<script setup>
import { NFlex } from 'naive-ui'; 
import { ref, computed } from 'vue';
import GradeClassChart from '@/components/result/GradeClassChart.vue'; 

const props = defineProps({
  type: { 
    type: String,
    required: true,
    validator: (value) => ['literacy', 'numeracy'].includes(value)
  }, 
  tableData: { 
    type: Array,
    required: true,
    default: () => []
  },
  chartData: {
    type: Array,
    default: () => [
      { level: '1수준', percentage: 0, count: 0 },
      { level: '2수준', percentage: 0, count: 0 },
      { level: '3수준', percentage: 0, count: 0 },
      { level: '4수준', percentage: 0, count: 0 }
    ]
  }
});

// 기본 하드코딩 데이터 (fallback용)
const classDataLiteracy = ref([
  { level: '1수준', percentage: 0, count: 0 },
  { level: '2수준', percentage: 14.8, count: 4 },
  { level: '3수준', percentage: 51.9, count: 13 },
  { level: '4수준', percentage: 33.3, count: 8 } 
]);

const classDataNumeracy = ref([
  { level: '1수준', percentage: 0, count: 0 },
  { level: '2수준', percentage: 14.8, count: 5 },
  { level: '3수준', percentage: 25.9, count: 7 },
  { level: '4수준', percentage: 51.9, count: 13 } 
]);

// 학생 이름 필터링 함수
const filterStudentNames = (studentString) => {
  if (!studentString || typeof studentString !== 'string') {
    return '';
  }
  
  // 쉼표로 구분하여 배열로 변환
  const names = studentString.split(',')
    .map(name => name.trim()) // 앞뒤 공백 제거
    .filter(name => name.length > 0); // 빈 문자열 제거
  
  // 필터링된 이름들을 다시 쉼표로 연결
  return names.join(', ');
};

const currentClassData = computed(() => {
  // props.chartData가 있으면 사용, 없으면 기본값 사용
  if (props.chartData && props.chartData.length > 0) {
    return props.chartData;
  }
  
  // fallback to hardcoded data
  if (props.type === 'literacy') {
    return classDataLiteracy.value;
  } else if (props.type === 'numeracy') {
    return classDataNumeracy.value;
  }
  return []; 
});

</script>

<template>
  <div class="card rate" :class="props.type">
    <h5 class="card-title" :class="props.type">수준별 학생 비율(수)</h5>
    <n-flex :wrap="false" :size="40" class="pt-5">      
      <GradeClassChart          
          :chartType="props.type"
          :level-data="currentClassData"
          :max-scale="100"
          chart-height="320px"
      /> 
      <table class="text-[18px]"> 
        <thead>
          <tr>
            <th>수준<br>(점수)</th>
            <th>명단</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in props.tableData" :key="index">
            <td><strong>{{ row.level }}</strong><br>({{ row.scoreRange }})</td>
            <td>{{ filterStudentNames(row.students) }}</td>
          </tr>
        </tbody>
      </table>                
    </n-flex>
  </div>
</template>

<style lang="scss" scoped>
table {
    border-collapse: collapse;
    border-radius: 10px;
    flex: 1;
    border-style: hidden;
    box-shadow: 0 0 0 1px #999;
    overflow: hidden;    
    line-height: 1.4;
    tr {         
        border-bottom: 1px solid #ccc;
        th {
            height: 60px;
            background-color: #F5F5F5;
            font-weight: 400;
            &:nth-child(1) { 
                border-right: 1px solid #ccc;
                text-align: center;
                width: 130px;
            }
        }
        td {
            height: 90px;
            padding: 10px;
            &:nth-child(1) { 
                border-right: 1px solid #ccc;
                text-align: center;
            }
        }
    }    
    tr:last-child {
        border: 0;
    }
}
.card.rate ::v-deep .level-chart-wrapper {
  padding: 40px 30px 20px 16px;
  .bar {width: 40px;}
  .chart-type {display: none;}
  .group-label {font-size: 18px; padding: 16px 0 0 0;}
} 
</style>